const { WarningItem } = require("_components");
const { groupWarningsByFamily, codeFamilles } = require("_helpers");

export { WarningsList };

function WarningsList({ warnings }) {

    const groupedWarnings = groupWarningsByFamily(warnings, codeFamilles);
    
    return (
        <>
        {groupedWarnings ? 
            <div className="warning-list flex flex-wrap gap-6">
            {Object.entries(groupedWarnings).map(([family, warnings], index) => (
                <div key={index} className="family-group flex flex-col mb-2 pl-8">
                    <h3 className="text-md text-global-mediumgrey mb-2">{family}</h3>
                    <div className="flex  gap-4">
                        {warnings.map((warning, warningIndex) => (
                            <WarningItem key={warningIndex} warning={warning} />
                        ))}
                    </div>
                </div>
            ))}
        </div> 
        :
        <p>Aucune Donnée</p>}
        </>
    );
};